export function getSettlementAccountsById(state) {
  return state.admin.settlementAccounts.byId;
}

export function getIsFetchingSettlementAccount(state) {
  return state.admin.settlementAccounts.isFetching;
}
